export const CurrentStats = {
  get: ({ interval }: { interval: string }) => `market-changes?interval=${interval}`
}
